<div class="header">
  <h1 mat-dialog-title [innerHTML]="data.title"></h1>
</div>
<div mat-dialog-content>
  <p class="dialog-message" [innerHTML]="data.message"></p>
</div>
<div mat-dialog-actions>
  <button
    class="buttonPortal cancel mb-3 w-100"
    (click)="cancel()"
    [innerHTML]="data.cancelText"
  ></button>
  <button
    class="buttonPortal mb-3 w-100"
    (click)="confirm()"
    [innerHTML]="data.confirmText"
  ></button>
</div>
